module.exports = __webpack_public_path__ + "static/media/duanwuBg1.6bee3957.jpg";